import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelContentService', HotelContentService);

  HotelContentService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'HotelContentModalService',
    'UploadService',
    'SessionService',
  ];

  function HotelContentService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    HotelContentModalService,
    UploadService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotel_contents';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getHotelsContents: getHotelsContents,
      getHotelContent: getHotelContent,
      saveHotelContent: saveHotelContent,
      openHotelContentTranslation: openHotelContentTranslation,
      openLogo: openLogo,
      updateLogo: updateLogo,
      deleteHotelContent: deleteHotelContent,
      changeHotelContentStatus: changeHotelContentStatus,
      changeHotelContentFeatured: changeHotelContentFeatured,
      changeHotelContentPublished: changeHotelContentPublished,
      openHotelContentsModal: openHotelContentsModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getHotelsContents(websiteId, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;
      filterCriteria.website_id = websiteId;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: utils.cleanItemsCache(response.data, 'logo'),
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getHotelContent(id, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveHotelContent(item, language, cropedImage) {
      var method;
      var url = apiUrl;

      if (!item.id) {
        // create
        method = 'post';
        url = apiUrl;
      } else {
        method = 'put';
        url = apiUrl + '/' + item.id;
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;
      url = url + '?lang=' + lang;

      return UploadService.uploadFile(
        method,
        url,
        'hotel_content',
        item,
        cropedImage,
        function () {},
        function (response) {
          var msg = item.id ? 'MODIFIED_CONTENT' : 'NEW_ADDED_CONTENT';
          utils._successMsg($translate(msg));

          if (!item.id) {
            // Create
            var itemAddedFlashMsg =
              $translate('CONTENT_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
            utils._setFlashMessage(itemAddedFlashMsg);
          }

          return response;
        },
        function () {}
      );
    }

    function openHotelContentTranslation(itemId, websiteName, additionalLanguages) {
      HotelContentModalService.openHotelContentTranslationsModal(
        itemId,
        websiteName,
        additionalLanguages
      );
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      var url = apiUrl + '/' + item.id;

      utils.updateLogo(url, 'hotel_content', item, cropedImage);
    }

    function deleteHotelContent(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_CONTENT',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            confirmButtonLabel: 'DELETE_CONTENT',
            successMsg: 'CONTENT_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeHotelContentStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeHotelContentFeatured(item) {
      utils.changeItemFeatured(apiUrl + '/' + item.id, item);
    }

    function changeHotelContentPublished(item) {
      utils.changeItemPublished(apiUrl + '/' + item.id, item);
    }

    function openHotelContentsModal(hotel) {
      HotelContentModalService.openHotelContentsModal(hotel);
    }
  }
})();
